import { List } from 'immutable';
import { PAID_POSTING_SOURCE, OPN_SOURCE, JOB_BOARD_BUNDLE_SOURCE } from 'constants/candidates';

export default function getSource(searchParams) {
  if (
    (searchParams.get('lead') == null || searchParams.get('lead').length === 0)
    && (searchParams.get('source') == null || searchParams.get('source').length === 0)
    && window.LANDINGPAGE.source
  ) {
    return window.LANDINGPAGE.source;
  }

  return searchParams.get('source') || searchParams.get('lead');
}

export function initProfileAttributes(searchParams) {
  let list = new List([
    { key: 'whatsapp_optin', value: 'No' },
  ]);

  // NOTE: If source is related to Vonq ads
  if ([PAID_POSTING_SOURCE, OPN_SOURCE].includes(searchParams.get('source'))) {
    if (searchParams.get('utmSource') && searchParams.get('utmSource').length > 0) {
      list = list.push({ key: 'utm_source', value: searchParams.get('utmSource') });
    }

    if (searchParams.get('utmCampaign') && searchParams.get('utmCampaign').length > 0) {
      list = list.push({ key: 'utm_campaign', value: searchParams.get('utmCampaign') });
    }

    if (searchParams.get('utmMedium') && searchParams.get('utmMedium').length > 0) {
      list = list.push({ key: 'utm_medium', value: searchParams.get('utmMedium') });
    }

    if (document.referrer && document.referrer.length > 0) {
      let referrer;
      try {
        referrer = new URL(document.referrer).host;
      } catch (error) {
        referrer = document.referrer;
      }

      list = list.push({ key: 'origin_site_url', value: referrer });
    }

    if (searchParams.get('source') === PAID_POSTING_SOURCE) {
      list = list.push({ key: 'ad_type', value: 'Paid' });

      if (searchParams.get('utmSource') === JOB_BOARD_BUNDLE_SOURCE) {
        list = list.push({ key: 'post_mode', value: 'Job Bundle' });
      } else {
        list = list.push({ key: 'post_mode', value: 'Single Post' });
      }
    }

    if (searchParams.get('source') === OPN_SOURCE) {
      list = list.push({ key: 'ad_type', value: 'Free' });
      list = list.push({ key: 'post_mode', value: 'Single Post' });
    }
  }

  return list;
}
